import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/bread/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var destroyServer;
var makeServer;
export var EVT_TYPE_STORAGE_CHANGED = 'bread.storageChange';
export var STORAGE_KEY = 'USE_MIRAGE';
var MIRAGE_ENV = 'development';
/**
 * Starts the Mirage server if enabled and not running.
 *
 * @returns Promise<void
 *
 */

export function startMockAPIServerIfConfigured() {
  return _startMockAPIServerIfConfigured.apply(this, arguments);
}
/**
 * Determines if Mirage server should be used.
 *
 * @returns boolean
 *
 */

function _startMockAPIServerIfConfigured() {
  _startMockAPIServerIfConfigured = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!shouldUseMockAPI()) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return startMockAPIServer();

          case 3:
            console.debug('Mirage Server: Started'); // eslint-disable-line no-console

            _context.next = 7;
            break;

          case 6:
            if (destroyServer) {
              destroyServer();
              console.debug('Mirage Server: Stopped'); // eslint-disable-line no-console
            }

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _startMockAPIServerIfConfigured.apply(this, arguments);
}

export function shouldUseMockAPI() {
  try {
    if (false) {
      return false;
    } // Should not run on the server


    var useMockAPI = window.localStorage.getItem(STORAGE_KEY);

    if (!useMockAPI) {
      useMockAPI = process.env.NEXT_PUBLIC_USE_MIRAGE || '';
    }

    return useMockAPI === 'true';
  } catch (e) {
    console.debug('Mirage Server: ' + e); // eslint-disable-line no-console

    return false;
  }
}

function startMockAPIServer() {
  return _startMockAPIServer.apply(this, arguments);
}

function _startMockAPIServer() {
  _startMockAPIServer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$import;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (makeServer) {
              _context2.next = 6;
              break;
            }

            _context2.next = 3;
            return import('./server');

          case 3:
            _yield$import = _context2.sent;
            destroyServer = _yield$import.destroyServer;
            makeServer = _yield$import.makeServer;

          case 6:
            makeServer({
              environment: MIRAGE_ENV
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _startMockAPIServer.apply(this, arguments);
}